import { inject, Injectable, signal } from '@angular/core';

export interface ConfirmState {
  title:       string;
  message:     string;
  confirmLabel: string;
  danger:      boolean;
  resolve:     (result: boolean) => void;
}

@Injectable({ providedIn: 'root' })
export class ConfirmService {
  readonly state = signal<ConfirmState | null>(null);

  confirm(
    message:      string,
    title         = '¿Confirmar acción?',
    confirmLabel  = 'Confirmar',
    danger        = false,
  ): Promise<boolean> {
    return new Promise(resolve => {
      this.state.set({ title, message, confirmLabel, danger, resolve });
    });
  }

  respond(result: boolean): void {
    this.state()?.resolve(result);
    this.state.set(null);
  }
}
